var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": "Create Export", role: "dialog" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [_vm._v("Create Export")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c("label", { attrs: { for: "report-name" } }, [_vm._v("Export Name")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.reportName,
              expression: "reportName",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "report-name", maxlength: "127" },
          domProps: { value: _vm.reportName },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.reportName = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-15-top" },
        [
          _c("span", [_vm._v("Include")]),
          _vm._v(" "),
          _c("tree-select", {
            attrs: { multiple: true, options: _vm.sectionsToSelect },
            model: {
              value: _vm.selectedItems,
              callback: function ($$v) {
                _vm.selectedItems = $$v
              },
              expression: "selectedItems",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-15-top" },
        [
          _c("vue-switch-with-label", {
            attrs: { label: "Show full logs", name: "show_full_logs" },
            model: {
              value: _vm.includeFullLog,
              callback: function ($$v) {
                _vm.includeFullLog = $$v
              },
              expression: "includeFullLog",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-green",
                attrs: { disabled: _vm.createDisabled, type: "button" },
                on: { click: _vm.createReport },
              },
              [_vm._v("\n                    Create\n                ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }